import { TFunction } from "i18next";
import aspectRatio1 from "../../../../../assets/images/pngs/BestPractices/aspectRatio1.png";
import aspectRatio2 from "../../../../../assets/images/pngs/BestPractices/aspectRatio2.png";
import definedCharacter1 from "../../../../../assets/images/pngs/BestPractices/definedCharacter1.png";
import definedCharacter2 from "../../../../../assets/images/pngs/BestPractices/definedCharacter2.png";
import definedCharacter3 from "../../../../../assets/images/pngs/BestPractices/definedCharacter3.png";
import diversity1 from "../../../../../assets/images/pngs/BestPractices/diversity1.png";
import diversity2 from "../../../../../assets/images/pngs/BestPractices/diversity2.png";
import diversity3 from "../../../../../assets/images/pngs/BestPractices/diversity3.png";
import focusOnSubject1 from "../../../../../assets/images/pngs/BestPractices/focusOnSubject1.png";
import focusOnSubject2 from "../../../../../assets/images/pngs/BestPractices/focusOnSubject2.png";
import minimizeMargins1 from "../../../../../assets/images/pngs/BestPractices/minimizeMargins1.png";
import minimizeMargins2 from "../../../../../assets/images/pngs/BestPractices/minimizeMargins2.png";
import restylePortraits1 from "../../../../../assets/images/pngs/BestPractices/restylePortrait1.png";
import restylePortraits2 from "../../../../../assets/images/pngs/BestPractices/restylePortrait2.png";
import restylePortraits3 from "../../../../../assets/images/pngs/BestPractices/restylePortrait3.png";

export const getBestPracticesData = (t: TFunction) => {
	return {
		diversityUseCases: [
			{
				title: t("diversitySection.useCases.balanceContent.title"),
				description: t("diversitySection.useCases.balanceContent.descr"),
				images: [diversity1, diversity2, diversity3],
			},
		],
		imageQualityUseCases: [
			{
				title: t("imageQualitySection.useCases.resolution.title"),
				description: t("imageQualitySection.useCases.resolution.descr"),
			},
			{
				title: t("imageQualitySection.useCases.aspectRatio.title"),
				list: [
					{
						text: t("imageQualitySection.useCases.aspectRatio.listItem1"),
					},
					{
						text: t("imageQualitySection.useCases.aspectRatio.listItem2"),
						images: [aspectRatio1, aspectRatio2],
					},
				],
			},
		],
		assetsUseCases: [
			{
				title: t("assetsSection.useCases.focusOnSubject.title"),
				description: t("assetsSection.useCases.focusOnSubject.descr"),
				images: [focusOnSubject1, focusOnSubject2],
			},
			{
				title: t("assetsSection.useCases.minimize.title"),
				description: t("assetsSection.useCases.minimize.descr"),
				images: [minimizeMargins1, minimizeMargins2],
			},
			{
				title: t("assetsSection.useCases.definedCharacters.title"),
				description: t("assetsSection.useCases.definedCharacters.descr"),
				images: [definedCharacter1, definedCharacter2, definedCharacter3],
			},
		],
		captionsUseCases: [
			{
				title: t("captionsSection.useCases.defaultPrefix.title"),
				description: t("captionsSection.useCases.defaultPrefix.descr"),
			},
			{
				title: t("captionsSection.useCases.customizingThePrefix.title"),
				description: t("captionsSection.useCases.customizingThePrefix.descr"),
			},
			{
				title: t("captionsSection.useCases.modifyingCaptions.title"),
				list: [
					{ text: t("captionsSection.useCases.modifyingCaptions.listItem1") },
					{ text: t("captionsSection.useCases.modifyingCaptions.listItem2") },
					{ text: t("captionsSection.useCases.modifyingCaptions.listItem3") },
				],
			},
			{
				title: t("captionsSection.useCases.bestPractices.title"),
				list: [
					{ text: t("captionsSection.useCases.bestPractices.listItem1") },
					{ text: t("captionsSection.useCases.bestPractices.listItem2") },
					{ text: t("captionsSection.useCases.bestPractices.listItem3") },
				],
			},
		],
		restylePortraits: [
			{
				title: t("restylePortraits.useCases.tailoredModelFeatures.title"),
				list: [
					{ text: t("restylePortraits.useCases.tailoredModelFeatures.listItem1") },
					{ text: t("restylePortraits.useCases.tailoredModelFeatures.listItem2") },
					{ text: t("restylePortraits.useCases.tailoredModelFeatures.listItem3") },
				],
			},
			{
				title: t("restylePortraits.useCases.portraitGuidelines.title"),
				list: [
					{ text: t("restylePortraits.useCases.portraitGuidelines.listItem1") },
					{ text: t("restylePortraits.useCases.portraitGuidelines.listItem2") },
				],
				images: [restylePortraits1, restylePortraits2, restylePortraits3],
			},
		],
	};
};
